import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock, ShieldCheck } from "lucide-react";
import { errMsg } from "@/lib/api";
import { cassa, setCassaToken } from "./cassaApi";

export function CassaGate() {
  const [st, setSt] = useState(null);
  const [pin, setPin] = useState("");
  const [pin2, setPin2] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { cassa.get("/status").then((r) => setSt(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const submit = async (e) => {
    e.preventDefault();
    if (!st.pin_set && pin !== pin2) return toast.error("I due PIN non coincidono");
    setBusy(true);
    try {
      const { data } = await cassa.post(st.pin_set ? "/unlock" : "/pin/setup", { pin });
      setCassaToken(data.token);
    } catch (x) { toast.error(errMsg(x)); setPin(""); }
    setBusy(false);
  };
  if (!st) return <div className="py-24 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  const pinInput = (v, set, id, ph) => (
    <input data-testid={id} type="password" inputMode="numeric" autoComplete="off" maxLength={12} value={v} placeholder={ph} autoFocus={id === "cassa-pin-input"}
      onChange={(e) => set(e.target.value.replace(/\D/g, ""))} className="w-full h-14 px-4 rounded-md border border-slate-300 text-center text-2xl tracking-[0.5em] font-mono focus:outline-none focus:ring-2 focus:ring-brand-yellow" />
  );
  return (
    <div className="max-w-sm mx-auto py-12" data-testid="cassa-gate">
      <form onSubmit={submit} className="rounded-2xl bg-brand-navy text-white p-8 space-y-5 shadow-xl">
        <div className="w-14 h-14 rounded-full bg-brand-yellow text-brand-navy grid place-items-center">{st.pin_set ? <Lock className="w-7 h-7" /> : <ShieldCheck className="w-7 h-7" />}</div>
        <div>
          <h1 className="text-3xl font-extrabold uppercase">Cassa</h1>
          <p className="text-sm text-white/70">{st.pin_set ? "Area riservata: inserisci il PIN della cassa." : "Primo accesso: scegli un PIN di 6-12 cifre. Ti servirà ogni volta che apri la Cassa."}</p>
        </div>
        <div className="space-y-3 text-slate-900">
          {pinInput(pin, setPin, "cassa-pin-input", "••••••")}
          {!st.pin_set && pinInput(pin2, setPin2, "cassa-pin-confirm-input", "ripeti")}
        </div>
        <button data-testid="cassa-unlock-btn" disabled={busy || pin.length < 6} className="press w-full h-12 rounded-md bg-brand-yellow text-brand-navy font-bold flex items-center justify-center gap-2 disabled:opacity-50">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} {st.pin_set ? "Sblocca" : "Imposta PIN e apri"}
        </button>
        <p className="text-[11px] text-white/60">Dopo {st.idle_minutes} minuti senza attività la Cassa si richiude da sola. Dati clienti e fatture sono crittografati.</p>
      </form>
    </div>
  );
}
